import React from 'react';
import PropTypes from 'prop-types';
import {Alert, Box, Link} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import {buildContactFormUrl} from '../../../../utility/contactFormUrlUtil';

const ReadonlySectionMessage = ({school, studentProfile, userAccount}) => {
    const schoolName = school?.name || 'the school';

    const contactFormUrl = buildContactFormUrl({
        schoolName: school?.name || '',
        studentFirstName: studentProfile?.name || '',
        studentLastName: studentProfile?.surname || '',
        userFirstName: userAccount?.firstName || '',
        userLastName: userAccount?.lastName || '',
        userEmail: userAccount?.email || '',
        pleaseChoose: 'I need to make a change to the information on my child\'s Admicity profile but I am unable to edit it OR I have a question relating to a form or email I have received',
    });

    return (
        <Box sx={{mb: 0}}>
            <Alert
                icon={<InfoIcon />}
                severity="info"
                sx={{
                    '& .MuiAlert-message': {
                        width: '100%'
                    }
                }}
            >
                <Box component="div" sx={{mb: 0}}>
                    <strong>Important Information for Parents:</strong>
                </Box>
                <Box component="div" sx={{mb: 0}}>
                    Some sections of this profile may be displayed in read-only mode, which means you cannot directly edit the information. However, you are still required to review and confirm that the information is correct.
                    If you notice any missing information or incorrect data, please contact {schoolName} to have it corrected <Link href={contactFormUrl} target="_blank" rel="noopener noreferrer" underline="always">using this form</Link>.
                </Box>
            </Alert>
        </Box>
    );
};

ReadonlySectionMessage.propTypes = {
    school: PropTypes.shape({
        name: PropTypes.string,
        emailAddresses: PropTypes.string,
        phone: PropTypes.string,
    }),
    studentProfile: PropTypes.shape({
        name: PropTypes.string,
        surname: PropTypes.string,
    }),
    userAccount: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        email: PropTypes.string,
    }),
};

export default ReadonlySectionMessage;